/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $('.SidebarMenu__Nav .Collapsible__Button.Link-Shop').click();

  $('.subscription-step:not(.step-open) .subscription-step__content').slideUp();

  // Open the next subscription step when "Next Step" button clicked

  $('.next-step-button').on('click', function(e){
    var stepContent = $(this).parent().parent();
    var nextStepContent = stepContent.parent().next('.subscription-step').find('.subscription-step__content');
    var nextStep = stepContent.parent().next('.subscription-step');
    let stepNumber = $(stepContent).parent().attr('data-step');
    let nextStepNumber = parseInt(stepNumber) + 1;

    e.preventDefault();
    $(stepContent).parent().removeClass('step-open');
    stepContent.slideUp();
    nextStepContent.slideDown();
    nextStep.addClass('step-open');

    setTimeout(function() {
      var stepOffset = nextStep.offset();
      window.scrollTo({
        top: stepOffset.top,
        left: 0,
        behavior: 'smooth'
      });
    }, 400)
    $(`.subscription-summary__step[data-step=${nextStepNumber}]`).show();
  });


  // Open a subscription step when the toggle is clicked

  $('.subscription-step__toggle').on('click', function(){
    $('.subscription-step__content').slideUp();
    $('.subscription-step').removeClass('step-open');

    $(this).next('.subscription-step__content').slideDown();
    $(this).parent().addClass('step-open');
  });

  // Show selected option in "Review your order" sidebar

  $('.subscription-summary__step:not(.summary-open)').hide();
  $('.build-subscription input[type="radio"]').change(function(){

    if(! $(this).attr('data-plan') ) {

    let selection = $(this).val();
    let currentStep = $(this).closest('.subscription-step').attr('data-step');
    let summaryItem = $(`.subscription-summary__step[data-step=${currentStep}]`);

    summaryItem.find('.subscription-step-result').text(selection);

    } else {
      let selection = $(this).attr('data-plan');
      let currentStep = $(this).closest('.subscription-step').attr('data-step');
      let summaryItem = $(`.subscription-summary__step[data-step=${currentStep}]`);

      summaryItem.find('.subscription-step-result').text(selection);
    }
  });

  // Allow editing of step when Edit button clicked
  $('.subscription-summary__step-header a').on('click', function(){
    let step = $(this).attr('data-step');
    let foundStep = $(`.subscription-step[data-step="${step}"]`);
    $(window).scrollTop(foundStep.offset().top);
    $('.subscription-step').find('.subscription-step__content').hide();
    $('.subscription-step').removeClass('step-open');
    foundStep.find('.subscription-step__content').show();
    foundStep.addClass('step-open');
  })

  // Carousel
  $('.iwt-carousel-wrapper').slick({
    slidesToShow: 3,
    centerMode: true,
    variableWidth: true,
    arrows: true,
    nextArrow: $('.iwt-carousel-next'),
    prevArrow: $('.iwt-carousel-previous')
  });

  // collapsibles
  $('.collapsible-content').slideUp();
  $('.summary-section__header a').on('click', function(e){
      e.preventDefault();
      $(this).parent().next().find('.collapsible-content').slideToggle();
  });
  $('.collapsible-content button[type="submit"]').click(function(){
    $(this).parent().parent().slideUp();
  })
});